import { Arch2 } from './Arch2';

export default Arch2;
